
import { CardHeader, IsPass } from 'components/common';
import { GradeSettingPopup } from 'components/popup';
import BreadCrumb from 'components/shared/BreadCrumb';
import { Sidebar } from 'components/shared/sidebar';
import { useGetCommonApi } from 'hooks';
import { Score } from 'pages/Score';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Form, InputGroup, Tab, Table, Tabs } from 'react-bootstrap';
import ScoreModal from './ScoreModal';
import * as XLSX from 'xlsx-js-style';
import { applyExcelStyles, writeExcelFile } from 'util/excelStyle';
import { loginUser } from 'recoil/loginUser';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { adminSubjectState } from 'recoil/subject/adminSubjectState';
import { useGetRequiredApi } from 'hooks/useGetRequiredApi';
import { useMutation, useQueries } from '@tanstack/react-query';
import { getDataQuery } from 'api';
import { postDataQuery } from 'api/board/postQuery';
import { use } from 'react';
import { subjectOptionDataState } from 'recoil/subject/subjectOptionDataState';
import OnlineAttendancePopup from 'components/popup/OnlineAttendancePopup';
import { teacherInfoState } from '../../recoil/subject/teacherInfoState';
import { sisCourseState } from '../../recoil/subject/sisCourseState';
import { downloadLoadingState } from 'recoil/loading/downloadLoadingState';
import moment from 'moment';

export function ScoreTeacher() {
  const [key, setKey] = useState('gradeStatus');
  const [visibleSettingPopup, setVisibleSettingPopup] = useState(false);
  const [visibleStudentGrade, setVisibleStudentGrade] = useState(false);
  const [popupType, setPopupType] = useState('');
  const [isRelativeEnabled, setIsRelativeEnabled] = useState(true);
  const [gradePoints, setGradePoints] = useState([]);
  const [ratioTotal, setRatioTotal] = useState(0);
  const [studentNumberTotal, setStudentNumberTotal] = useState(0);
  const [updateGradeGroupList, setUpdateGradeGroupList] = useState([])
  const [isEditing, setIsEditing] = useState(false)
  const [attendanceLength, setAttendanceLength] = useState(0);
  const [nonAttendanceLength, setNonAttendanceLength] = useState(0);
  const [groupedLength, setGroupedLength] = useState(0);
  const [editableGradeList, setEditableGradeList] = useState([]);
  const [uploadedData, setUploadedData] = useState([]);
  const [inputKey, setInputKey] = useState(Date.now());
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({ userNumber: '', userLmsNumber: '', userName: '', totalScore: '', finalGrade: '', attendanceCnt: 0, absenceCnt: 0 });
  const user = useRecoilValue(loginUser);
  const [searchTerm, setSearchTerm] = useState('');
  const [gradeFilter, setGradeFilter] = useState(null);
  const [subjectState, setSubjectState] = useRecoilState(subjectOptionDataState);
  const [adminSelectState, setAdminSelectState] = useRecoilState(adminSubjectState);
  const [selectTeacherInfo, setSelectTeacherInfo] = useRecoilState(teacherInfoState);
  const [sisCourseIdState, setSisCourseIdState] = useRecoilState(sisCourseState);
  const [attendanceListMode, setAttendanceListMode] = useState(false);
  const [filteredAdvisorList, setFilteredAdvisorList] = useState(selectTeacherInfo.filteredAdvisors || []);
  const [selectedMainTeacherNumber, setSelectedMainTeacherNumber] = useState(selectTeacherInfo.managerNumber || '');
  const [isAdvisorLoading, setIsAdvisorLoading] = useState(false);

  const {
    // 학기정보
    semestersData,
  } = useGetCommonApi();

  const { adminSelectBoxQueryData, adminSubSelectBoxQueryData, adminTeacherInfoSelectBoxQueryData, teacherInfoSelectBoxQueryData, teacherTermSelectBoxQueryData } = useGetRequiredApi(
    adminSelectState.lectureId,
    subjectState.openYy,
    subjectState.openTmGbn,
    sisCourseIdState.scCd,
    sisCourseIdState.openDeptCd
  );

  const teacherInfoData = user.role === 'ADMIN' ? adminTeacherInfoSelectBoxQueryData : teacherInfoSelectBoxQueryData;
  const mainTeachers = useMemo(() => teacherInfoData?.flatMap(item => item.mainTeachers) || [], [teacherInfoData]);
  const advisorTeachers = useMemo(() => teacherInfoData?.flatMap(item => item.advisorTeachers) || [], [teacherInfoData]);
  const myAdvisorCourses = advisorTeachers.filter(item => item.teacherNumber === user.loginId);
  const isAdvisorProfessor = myAdvisorCourses.length > 0;
  const isMainProfessor = mainTeachers.some(item => item.teacherNumber === user.loginId);
  const filteredMainProfessors = (!isAdvisorProfessor && isMainProfessor)
    ? mainTeachers
    : mainTeachers.filter(mainProf =>
        mainProf.teacherNumber === user.loginId ||
        myAdvisorCourses.some(advisorCourse =>
          mainProf.courseTeacherInfo.some(mainCourse =>
            advisorCourse.courseTeacherInfo.some(ac => ac.sisCourseId === mainCourse.sisCourseId)
          )
        )
      );
  const teacherSubjectApis = useQueries({
    queries: [
      {
        // 교수자 - [학습현황] 과목을 수강중인 학생들의 목록
        queryKey: ['teacherSubjectStudentList', user, subjectState],
        queryFn: () => getDataQuery(`/teach/courses/${subjectState.courseId}/students`),
        enabled: !!subjectState.courseId,
      },
      {
        // 교수자 - [성적현황] 과목의 등급설정 조회
        queryKey: ['teacherGradeSettingList', user, subjectState],
        queryFn: () => getDataQuery(`/course/${subjectState.courseId}/grade_setting`),
        enabled: !!subjectState.courseId,
      },
      {
        // 교수자 - [성적현황] 과목의 성적평가표 조회
        queryKey: ['teacherGradeGroupList', user, subjectState],
        queryFn: () => getDataQuery(`/course/${subjectState.courseId}/grade_group`),
        enabled: !!subjectState.courseId,
      },
      {
        // 교수자 - [성적현황] 과목의 성적 현황 조회
        queryKey: ['teacherGradeList', user, subjectState, attendanceListMode, selectTeacherInfo],
        queryFn: () => getDataQuery(`/course/${subjectState.courseId}/grade?teacherNum=${selectTeacherInfo.advisorNumber || 0}&openYy=${sisCourseIdState.openYy}&openTmGbn=${sisCourseIdState.openTmGbn}&allFlag=${attendanceListMode}`),
        enabled: !!subjectState.courseId && !!sisCourseIdState.openTmGbn && !!sisCourseIdState.openYy,
      },
      {
        // 교수자 - [출결현황] 출석평가표(현장)
        queryKey: ['teacherAttendanceSettingList', user, subjectState],
        queryFn: () => getDataQuery(`/course/${subjectState.courseId}/attendance-setting`),
        enabled: !!subjectState.courseId,
      },
      {
        // 교수자 - [출결현황] 출석평가표(온라인)
        queryKey: ['teacherOnlineAttendanceSettingList', user, subjectState],
        queryFn: () => getDataQuery(`/attendance-online-setting/${subjectState.courseId}`),
        enabled: !!subjectState.courseId,
      },
    ],
  });
  
  const [
    teacherSubjectStudentListData,
    teacherGradeSettingList = { useRelativeEvaluation: false, evaluationCriteria: '', gradePointCreateDto: [] },
    teacherGradeGroupList,
    teacherGradeList,
    teacherAttendanceSettingList,
    teacherOnlineAttendanceSettingList,
  ] = teacherSubjectApis?.map((query) => query?.data?.data || []);
  
  const [
    refetchSubjectStudentListData,
    refetchGradeSettingList,
    refetchGradeGroupList,
    refetchGradeList,
    refetchAttendanceSettingList,
    refetchOnlineAttendanceSettingList,
  ] = teacherSubjectApis?.map((query) => query?.refetch) || [];

  const isGradeLoading = teacherSubjectApis?.[3]?.isFetching;

  // TEACHER: 대시보드에서 선택한 지도교수로 대표교수 pre-select
  useEffect(() => {
    if (user.role !== 'TEACHER') return;
    if (!selectTeacherInfo.advisorNumber || !advisorTeachers.length || !mainTeachers.length) return;
    if (selectedMainTeacherNumber) return;
    const advisor = advisorTeachers.find(a => a.teacherNumber === selectTeacherInfo.advisorNumber);
    if (!advisor) return;
    const mainTeacher = filteredMainProfessors.find(main =>
      main.courseTeacherInfo.some(mainCourse =>
        advisor.courseTeacherInfo.some(ac => ac.sisCourseId === mainCourse.sisCourseId)
      )
    );
    if (!mainTeacher) return;
    setSelectedMainTeacherNumber(mainTeacher.teacherNumber);
  }, [advisorTeachers, mainTeachers]);

  // TEACHER: 대표교수 선택 시 지도교수 리스트 API 호출 (대시보드 동일 방식)
  useEffect(() => {
    if (user.role !== 'TEACHER') return;
    if (!selectedMainTeacherNumber || !teacherTermSelectBoxQueryData?.length || !mainTeachers.length) return;
    const selectedProfessor = mainTeachers.find(item => item.teacherNumber === selectedMainTeacherNumber);
    if (!selectedProfessor?.courseTeacherInfo?.length) return;
    const fetchAdvisors = async () => {
      const sisCourseId = selectedProfessor.courseTeacherInfo[0].sisCourseId;
      const matchedCourse = teacherTermSelectBoxQueryData.find(c => c.sis_course_id === sisCourseId);
      if (!matchedCourse) return;
      const parts = sisCourseId.split('-');
      setIsAdvisorLoading(true);
      const res = await getDataQuery(
        `/teach/info/advisors?courseId=${matchedCourse.course_id}&openYy=${parts[0]}&openTmGbn=${parts[1]}&sisCourseId=${sisCourseId}`
      );
      let filteredAdvisors = res?.data || [];
      if (isAdvisorProfessor && !isMainProfessor) {
        filteredAdvisors = filteredAdvisors.filter(advisor => advisor.teacherNumber === user.loginId);
      }
      setFilteredAdvisorList(filteredAdvisors);
      setSubjectState(prev => ({ ...prev, courseId: matchedCourse.course_id }));
      setIsAdvisorLoading(false);
    };
    fetchAdvisors();
  }, [selectedMainTeacherNumber, teacherTermSelectBoxQueryData, mainTeachers]);

  // ADMIN: 학과 선택 시 sisCourseIdState 설정
  useEffect(() => {
    if (user.role !== 'ADMIN' || !adminSubSelectBoxQueryData?.length) return;
    const firstItem = adminSubSelectBoxQueryData[0].account_course_dto.sis_course_id;
    const parts = firstItem.split('-');
    const semesterYear = `${parts[0]}-${parts[1]}`;
    setSisCourseIdState({
      openYy: parts[0] || null,
      openTmGbn: parts[1] || null,
      scCd: parts[2] || null,
      openDeptCd: semesterYear === '2024-10' ? parts[3] || null : parts.at(-1) || null,
    });
  }, [adminSubSelectBoxQueryData]);

  // ADMIN: 지도교수 선택 시 courseId 설정
  useEffect(() => {
    if (user.role !== 'ADMIN' || !selectTeacherInfo.advisorNumber || !adminSubSelectBoxQueryData?.length) return;
    const selectedAdvisor = filteredAdvisorList.find(a => a.teacherNumber === selectTeacherInfo.advisorNumber);
    if (!selectedAdvisor?.courseTeacherInfo?.length) return;
    const selectedMainProfessor = mainTeachers.find(item => item.teacherNumber === selectedMainTeacherNumber);
    const matchingCourseInfo = selectedMainProfessor
      ? selectedAdvisor.courseTeacherInfo.find(course =>
          selectedMainProfessor.courseTeacherInfo.some(mc => mc.sisCourseId === course.sisCourseId)
        )
      : selectedAdvisor.courseTeacherInfo[0];
    if (!matchingCourseInfo) return;
    const advisorSisCourseId = matchingCourseInfo.sisCourseId;
    const matchingCourse = adminSubSelectBoxQueryData.find(
      item => item.account_course_dto.sis_course_id === advisorSisCourseId
    );
    if (matchingCourse) {
      setSubjectState(prev => ({ ...prev, courseId: matchingCourse.account_course_dto.course_id }));
    }
  }, [selectTeacherInfo.advisorNumber, filteredAdvisorList]);

  // TEACHER: 지도교수 선택 시 courseId 설정
  useEffect(() => {
    if (user.role !== 'TEACHER' || !selectTeacherInfo.advisorNumber || !teacherTermSelectBoxQueryData?.length) return;
    const selectedAdvisor = filteredAdvisorList.find(a => a.teacherNumber === selectTeacherInfo.advisorNumber);
    if (!selectedAdvisor?.courseTeacherInfo?.length) return;
    const selectedMainProfessor = mainTeachers.find(item => item.teacherNumber === selectedMainTeacherNumber);
    const matchingCourseInfo = selectedMainProfessor
      ? selectedAdvisor.courseTeacherInfo.find(course =>
          selectedMainProfessor.courseTeacherInfo.some(mc => mc.sisCourseId === course.sisCourseId)
        )
      : selectedAdvisor.courseTeacherInfo[0];
    if (!matchingCourseInfo) return;
    const advisorSisCourseId = matchingCourseInfo.sisCourseId;
    const matchingCourse = teacherTermSelectBoxQueryData.find(
      item => item.sis_course_id === advisorSisCourseId
    );
    if (matchingCourse) {
      setSubjectState(prev => ({ ...prev, courseId: matchingCourse.course_id }));
    }
  }, [selectTeacherInfo.advisorNumber, filteredAdvisorList]);

  const handleAdminSelectTermBox = (e) => {
    setSelectTeacherInfo(prev => ({ ...prev, advisorNumber: null, advisorName: null }));
    setFilteredAdvisorList([]);
    setSelectedMainTeacherNumber('');
    const selected = semestersData?.data?.find(item => item.id === Number(e.target.value));
    const sisTermId = selected?.sis_term_id || '';
    const openYy = sisTermId.length >= 4 ? parseInt(sisTermId.substring(0, 4)) : null;
    const openTmGbn = sisTermId.length > 4 ? parseInt(sisTermId.substring(4)) : null;
    setSubjectState(prev => ({ ...prev, termId: e.target.value, termName: selected?.name || '', openYy, openTmGbn }));
  };

  const handleAdminSelectDeptBox = (e) => {
    setSelectTeacherInfo(prev => ({ ...prev, advisorNumber: null, advisorName: null }));
    setFilteredAdvisorList([]);
    setSelectedMainTeacherNumber('');
    if (!e.target.value) return;
    setAdminSelectState(prev => ({ ...prev, lectureId: e.target.value, lectureTitle: e.target.options[e.target.selectedIndex]?.text || '' }));
  };

  const handleAdminSelectMainTeacherBox = async (e) => {
    const selectedTeacherNumber = e.target.value;
    const selectedName = e.target.options[e.target.selectedIndex].text;
    setSelectTeacherInfo(prev => ({ ...prev, managerNumber: selectedTeacherNumber || null, managerName: selectedName || null, advisorNumber: null, advisorName: null }));
    setSelectedMainTeacherNumber(selectedTeacherNumber);
    setFilteredAdvisorList([]);
    setIsAdvisorLoading(false);
    if (!selectedTeacherNumber) return;
    const selectedProfessor = mainTeachers.find(item => item.teacherNumber === selectedTeacherNumber);
    if (!selectedProfessor?.courseTeacherInfo?.length) return;
    const sisCourseId = selectedProfessor.courseTeacherInfo[0].sisCourseId;
    const parts = sisCourseId.split('-');
    if (user.role === 'TEACHER') {
      // TEACHER: teacherTermSelectBoxQueryData 기반으로 지도교수 리스트 가져오기
      const matchedCourse = teacherTermSelectBoxQueryData?.find(c => c.sis_course_id === sisCourseId);
      if (!matchedCourse) return;
      setIsAdvisorLoading(true);
      const res = await getDataQuery(
        `/teach/info/advisors?courseId=${matchedCourse.course_id}&openYy=${parts[0]}&openTmGbn=${parts[1]}&sisCourseId=${sisCourseId}`
      );
      let filteredAdvisors = res?.data || [];
      if (isAdvisorProfessor && !isMainProfessor) {
        filteredAdvisors = filteredAdvisors.filter(advisor => advisor.teacherNumber === user.loginId);
      }
      setFilteredAdvisorList(filteredAdvisors);
      setSubjectState(prev => ({ ...prev, courseId: matchedCourse.course_id }));
      setIsAdvisorLoading(false);
      return;
    }
    // ADMIN: API 호출로 지도교수 리스트 가져오기
    const matchedCourse = adminSubSelectBoxQueryData?.find(item => item.account_course_dto.sis_course_id === sisCourseId);
    if (!matchedCourse) return;
    setIsAdvisorLoading(true);
    const res = await getDataQuery(
      `/teach/info/advisors?courseId=${matchedCourse.account_course_dto.course_id}&openYy=${parts[0]}&openTmGbn=${parts[1]}&sisCourseId=${sisCourseId}`
    );
    setFilteredAdvisorList(res?.data || []);
    setSubjectState(prev => ({ ...prev, courseId: matchedCourse.account_course_dto.course_id }));
    setIsAdvisorLoading(false);
  };

  const handleAdminSelectAdvisorBox = (e) => {
    if (!e.target.value) {
      setSelectTeacherInfo(prev => ({ ...prev, advisorNumber: null, advisorName: null }));
      setAttendanceListMode(true);
      return;
    }
    const selectedAdvisor = filteredAdvisorList.find(item => item.teacherNumber === e.target.value);
    if (!selectedAdvisor) return;
    setSelectTeacherInfo(prev => ({ ...prev, advisorNumber: selectedAdvisor.teacherNumber, advisorName: selectedAdvisor.teacherName }));
    setAttendanceListMode(false);
  };

  const handleNameClick = (userNumber, userLmsNumber, userName, totalScore, finalGrade, attendanceCnt, absenceCnt) => {
    setSelectedStudent({ userNumber, userLmsNumber, userName, totalScore, finalGrade, attendanceCnt, absenceCnt });
    setVisiblePopup(true);
  };

  const handleAllAttendanceListClick = () => {
    setAttendanceListMode(true);
  };

  const handleToggleAttendanceListClick = () => {
    setAttendanceListMode(prev => !prev);
  };

  const [sortConfig, setSortConfig] = useState({ key: 'userName', direction: 'asc' });

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { key, direction: 'asc' };
    });
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return ' ↕';
    return sortConfig.direction === 'asc' ? ' ▲' : ' ▼';
  };

  const getSortValue = (student) => {
    switch (sortConfig.key) {
      case 'userName':
        return (student?.userName ?? '').toString().toLowerCase();
      case 'userNumber':
        return (student?.userNumber ?? '').toString();
      case 'totalScore':
        return Number(student?.totalScore ?? 0);
      case 'attendance': {
        const completed = Number(student?.attendanceCount ?? 0);
        const total = Number(student?.totalAttendanceCount ?? 0);
        return total > 0 ? completed / total : 0;
      }
      case 'tutorName':
        return (student?.tutorName ?? '').toString().toLowerCase();
      case 'totalGrade':
        return student?.totalGrade ? 1 : 0;
      default:
        return 0;
    }
  };

  const displayStudents = useMemo(() => {
    const list = Array.isArray(teacherGradeList) ? teacherGradeList : [];
    const trimmedSearch = searchTerm.trim().toLowerCase();

    const searchFiltered = trimmedSearch
      ? list.filter((student) => {
        const name = (student?.userName ?? '').toString().toLowerCase();
        const num = (student?.userNumber ?? '').toString();
        return name.includes(trimmedSearch) || num.includes(trimmedSearch);
      })
      : list;

    const filtered = gradeFilter !== null
      ? searchFiltered.filter((student) => student.totalGrade === gradeFilter)
      : searchFiltered;

    const indexed = filtered.map((s, idx) => ({ s, idx }));
    indexed.sort((a, b) => {
      const av = getSortValue(a.s);
      const bv = getSortValue(b.s);

      let cmp = 0;

      // 문자열/숫자 비교 분기
      if (typeof av === 'string' && typeof bv === 'string') {
        cmp = av.localeCompare(bv, 'ko');
      } else {
        cmp = av < bv ? -1 : av > bv ? 1 : 0;
      }

      if (cmp === 0) return a.idx - b.idx;
      return sortConfig.direction === 'asc' ? cmp : -cmp;
    });

    return indexed.map((x) => x.s);
  }, [teacherGradeList, searchTerm, sortConfig, gradeFilter]);

  const setDownloadLoading = useSetRecoilState(downloadLoadingState);
  const handleDownloadExcel = async () => {
    setDownloadLoading(true);
    await new Promise(resolve => setTimeout(resolve, 100));
    try {
    const wsData = [];
    const headers = ["번호", "이름", "학번", "지도교수", "총 점수", "출석", "미출석", "최종 등급 (P/N)"];
    wsData.push(headers);

    displayStudents?.forEach((student, index) => {
      wsData.push([
        index + 1,
        student.userName,
        student.userNumber,
        student.tutorName || '미배정',
        student.totalScore,
        student.attendanceCount,
        (student.totalAttendanceCount ?? 0) - (student.attendanceCount ?? 0),
        student.totalGrade ? 'Pass' : 'None-Pass',
      ]);
    });
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    applyExcelStyles(ws, 1);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Attendance");
    const departmentName = adminSelectState?.lectureTitle || subjectState.subAccountName || '';
    const termName = subjectState.termName || '';
    writeExcelFile(wb, `${departmentName}_성적_${termName}_${moment().format('YYMMDD_HHmm')}.xlsx`);
    } finally {
      setDownloadLoading(false);
    }
  };

    console.log(teacherGradeList)

  return (
    <>
      <Sidebar />
      <main id='main' className='main'>
        <BreadCrumb home={'/'} sublink={'/grade'} title={'성적 (Grade)'} subTitle={'성적현황'} />
        {user.role === 'ADMIN' && (
          <div className='d-flex align-items-center p-3' style={{ gap: '1rem', flexWrap: 'wrap', borderBottom: '1px solid #dee2e6' }}>
            <Form.Select value={subjectState.termId || ''} onChange={handleAdminSelectTermBox} className='d-none'>
              <option value=''>학기 선택</option>
              {semestersData?.data?.map(item => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
            </Form.Select>
            {subjectState.openYy && subjectState.openTmGbn && (
              <Form.Select value={adminSelectState.lectureId || ''} onChange={handleAdminSelectDeptBox} className='d-none'>
                <option value=''>학과 선택</option>
                {adminSelectBoxQueryData?.map(item => (
                  <option key={item.id} value={item.id}>{item.name}</option>
                ))}
              </Form.Select>
            )}
            {adminSelectState.lectureId && mainTeachers.length > 0 && (
              <Form.Select value={selectedMainTeacherNumber} onChange={handleAdminSelectMainTeacherBox} style={{ width: '200px' }}>
                <option value=''>대표교수 선택</option>
                {mainTeachers.map(item => (
                  <option key={item.teacherNumber} value={item.teacherNumber}>{item.teacherName}</option>
                ))}
              </Form.Select>
            )}
            {selectedMainTeacherNumber && !isAdvisorLoading && (
              <Form.Select value={selectTeacherInfo.advisorNumber || ''} onChange={handleAdminSelectAdvisorBox} style={{ width: '200px' }}>
                <option value=''>지도교수 선택</option>
                {filteredAdvisorList.map(item => (
                  <option key={item.teacherNumber} value={item.teacherNumber}>{item.teacherName}</option>
                ))}
              </Form.Select>
            )}
          </div>
        )}
        {user.role === 'TEACHER' && parseInt(subjectState.openYy) >= 2025 && teacherTermSelectBoxQueryData?.length > 0 && (
          <div className='d-flex align-items-center p-3' style={{ gap: '1rem', flexWrap: 'wrap', borderBottom: '1px solid #dee2e6' }}>
            <Form.Select value={selectedMainTeacherNumber} onChange={handleAdminSelectMainTeacherBox} style={{ width: '200px' }}>
              <option value=''>대표교수 선택</option>
              {filteredMainProfessors.map(item => (
                <option key={item.teacherNumber} value={item.teacherNumber}>
                  {item.courseTeacherInfo?.map(c => c.courseName).join(', ')} - {item.teacherName}
                </option>
              ))}
            </Form.Select>
            {selectedMainTeacherNumber && !isAdvisorLoading && (
              <Form.Select value={selectTeacherInfo.advisorNumber || ''} onChange={handleAdminSelectAdvisorBox} style={{ width: '200px' }}>
                <option value=''>지도교수 선택</option>
                {filteredAdvisorList.map(item => (
                  <option key={item.teacherNumber} value={item.teacherNumber}>{item.teacherName}</option>
                ))}
              </Form.Select>
            )}
          </div>
        )}
        <div className='card p-20'>
        {isGradeLoading ? (
          <div className='d-flex justify-content-center align-items-center py-5'>
            <div className='spinner-border spinner-border-sm me-2' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
            데이터를 불러오는 중입니다...
          </div>
        ) : teacherGradeList ? (
          <>
            <div className="table-container" style={{ position: 'relative' }}>
              <div
                id="sticky-header"
                style={{
                  ...(visiblePopup ? {} : { position: "sticky", top: 0, zIndex: 10, background: "white" }),
                }}
              >
                <div className="d-flex justify-content-between align-items-center py-2">
                  <div className="d-flex gap-2">
                    <p
                      className={`fw-bold noto-sans fz-16 py-1 px-3 rounded-5 text-nowrap lh-22 isSuccess-green mb-0`}
                      style={{ cursor: 'pointer', opacity: gradeFilter === true ? 1 : 0.4 }}
                      onClick={() => setGradeFilter(prev => prev === true ? null : true)}
                    >
                      Pass
                    </p>
                    <p
                      className={`fw-bold noto-sans fz-16 py-1 px-3 rounded-5 text-nowrap lh-22 isSuccess-red mb-0`}
                      style={{ cursor: 'pointer', opacity: gradeFilter === false ? 1 : 0.4 }}
                      onClick={() => setGradeFilter(prev => prev === false ? null : false)}
                    >
                      None-pass
                    </p>
                  </div>
                  <form className="d-flex">
                    <Form.Control
                      type="text"
                      placeholder="이름 / 학번 검색"
                      className="me-3"
                      style={{ width: '188px' }}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <Button variant="primary" onClick={handleDownloadExcel}>
                      <i className="bi bi-download"></i>
                    </Button>
                    {sisCourseIdState.openYy !== '2024' && (
                      <>
                        <Button type='button' variant={!attendanceListMode ? 'primary' : 'outline-primary'} style={{marginLeft: '10px'}} onClick={() => setAttendanceListMode(false)}>
                          지도교수 리스트
                        </Button>
                        <Button type='button' variant={attendanceListMode ? 'primary' : 'outline-primary'} style={{marginLeft: '10px'}} onClick={() => { setAttendanceListMode(true); setSelectTeacherInfo(prev => ({ ...prev, advisorNumber: null, advisorName: null })); }}>
                          전체 리스트
                        </Button>
                      </>
                    )}
                  </form>
                </div>
              </div>

              {/* 테이블 */}
              <div style={{ overflowX: 'auto' }}>
                <Table>
                  {/* 헤더 */}
                  <thead className="border border-start-0 border-end-0">
                    <tr>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border border-start-0 border-end-0"
                        style={{ background: '#EBF1FA',
                                 minWidth: '100px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center' }}
                      >
                        <div className="d-flex justify-content-center align-items-center">번호</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border border-start-0"
                        style={{ minWidth: '130px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center',
                                 cursor: 'pointer'
                         }}
                        onClick={() => handleSort('userName')}
                      >
                        <div className="d-flex justify-content-center align-items-center">이름{renderSortIcon('userName')}</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border border-start-0 border-end-0"
                        style={{ minWidth: '130px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center',
                                 cursor: 'pointer'
                        }}
                        onClick={() => handleSort('userNumber')}
                      >
                        <div className="d-flex justify-content-center align-items-center">학번{renderSortIcon('userNumber')}</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border"
                        style={{ minWidth: '130px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center',
                                 cursor: 'pointer'
                        }}
                        onClick={() => handleSort('tutorName')}
                      >
                        <div className="d-flex justify-content-center align-items-center">지도교수{renderSortIcon('tutorName')}</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border"
                        style={{ minWidth: '120px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center',
                                 cursor: 'pointer'
                        }}
                        onClick={() => handleSort('totalScore')}
                      >
                        <div className="d-flex justify-content-center align-items-center">총 점수{renderSortIcon('totalScore')}</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border"
                        style={{ minWidth: '120px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center',
                                 cursor: 'pointer'
                         }}
                        onClick={() => handleSort('attendance')}
                      >
                        <div className="d-flex justify-content-center align-items-center gap-1">
                          <span>출석</span><span>/</span><span>미출석</span>
                          {renderSortIcon('attendance')}
                        </div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border"
                        style={{ minWidth: '120px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center',
                                 cursor: 'pointer'
                         }}
                        onClick={() => handleSort('totalGrade')}
                      >
                        <div className="d-flex justify-content-center align-items-center">최종 등급 (P/N){renderSortIcon('totalGrade')}</div>
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    {displayStudents?.map((student, index) => (
                      <tr key={student.userNumber}>
                        {/* 기본 정보 */}
                        <td
                          className="border border-start-0 border-end-0"
                          style={{ background: '#EBF1FA' }}
                        >
                          <div className="d-flex justify-content-center">{index + 1}</div>
                        </td>
                        <td className="border border-start-0">
                          <div
                            className="d-flex justify-content-center align-items-center gap-1 Blue-500 cursor-pointer"
                            onClick={() => handleNameClick(student.userNumber, student.userLmsNumber, student.userName, student.totalScore, student.totalGrade, student.attendanceCount, (student.totalAttendanceCount ?? 0) - (student.attendanceCount ?? 0))}
                          >
                            {student.userName}
                            {student.studentStatus && (
                              <span className='badge bg-warning text-dark' style={{ fontSize: '11px', fontWeight: 'normal' }}>{student.studentStatus}</span>
                            )}
                          </div>
                        </td>
                        <td className="border border-start-0 border-end-0">
                          <div className="d-flex justify-content-center">{student.userNumber}</div>
                        </td>
                        <td className="border">
                          <div className="d-flex justify-content-center">{student.tutorName || '미배정'}</div>
                        </td>
                        <td className="border">
                          <div className="d-flex justify-content-center">{student.totalScore} / 100</div>
                        </td>
                        <td className="border">
                          <div className="d-flex justify-content-center gap-1">
                            <span style={{ color: '#61BF5E' }}>{student.attendanceCount}</span>
                            <span>/</span>
                            <span style={{ color: '#D92B2B' }}>{(student.totalAttendanceCount ?? 0) - (student.attendanceCount ?? 0)}</span>
                          </div>
                        </td>
                        <td className="border">
                          <div className="d-flex justify-content-center"><IsPass completed={student.totalGrade} /></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
          ) : (
            ""
          )}
        </div>
      </main>
        {visiblePopup && (
          <OnlineAttendancePopup
            setVisiblePopup={setVisiblePopup}
            userNumber={selectedStudent.userNumber}
            userLmsNumber={selectedStudent.userLmsNumber}
            userName={selectedStudent.userName}
            courseId={subjectState.courseId}
            type={'grade'}
            totalScore={selectedStudent.totalScore}
            finalGrade={selectedStudent.finalGrade}
            attendanceCnt={selectedStudent.attendanceCnt}
            absenceCnt={selectedStudent.absenceCnt}
          />
        )}
      </>
  );
}
